module.exports = __webpack_public_path__ + "static/media/09_1_WHEEL_Team_RT-Movers_AlessandroDellaBella_102.f67df041.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle09/09_1_WHEEL_Team_RT-Movers_AlessandroDellaBella_102.jpg
 ** module id = 141
 ** module chunks = 0
 **/